const currentYear = new Date().getFullYear();

const locale = {
    code: "ja",
    label: "日本語",
    NAV_BAR: {
        home: "ホーム",
        homeId: "home",
        aboutus: "会社概要",
        aboutId: "aboutus",
        faq: "FAQ",
        faqId: "faq-section",
        contact: "お問い合わせ",
        contactId: "contact-section",
        button: "早期アクセス",
    },

    HERO: {
        heroHeading: "あなたのメニューがすぐにアクセス可能",
        heroParagraph:
            "ひとつのQRコードでメニューを作成、更新、共有できます。手間なし、再印刷不要です。",
        button: "早期アクセス",
        downloadText: "ダウンロード先",
        appStore: "App Store",
        getItOn: "GET IT ON",
        googlePlay: "Google Play",
    },

    SERVICES: {
        heading: "私たちのサービス",
        cards: [
            {
                title: "メニューを作成してアップロード",
                description:
                    "数回のクリックで簡単にメニューを作成してアップロードできます！アイテムを追加し、価格を設定し、技術的なスキルなしで詳細を更新します。",
            },
            {
                title: "メニューを更新",
                description:
                    "いつでもどこでもメニューをリアルタイムで更新できます！価格を変更し、新しい料理を追加し、利用不可のアイテムを即座にアーカイブします。",
            },
            {
                title: "生成して共有",
                description:
                    "メニューのためのユニークなQRコードをすぐに生成できます！テーブルやポスター、オンラインで共有して、顧客がスキャンして最新メニューにアクセスできるようにします。",
            },
        ],
    },

    FEATURES: {
        heading: "素晴らしい機能を体験しましょう",
        lists: [
            {
                title: "メニューを管理",
                description:
                    "いつでもメニューを管理できます！アイテムを追加、編集、削除して、提供内容を最新に保ちます。",
            },
            {
                title: "インサイトとレポート",
                description:
                    "リアルタイムレポートで価値あるインサイトを得ましょう！メニュービュー、QRコードスキャン、顧客のやり取りを追跡します。",
            },
            {
                title: "QRコードを共有",
                description:
                    "ユニークなQRコードでメニューを共有しましょう！テーブルやポスター、オンラインで表示して、顧客がすぐにスキャンできるようにします。",
            },
            {
                title: "顧客レビュー",
                description:
                    "実際の顧客のフィードバックと評価を表示しましょう！信頼を築き、メニューを改善し、食事体験を向上させます。",
            },
            {
                title: "オファーと割引",
                description:
                    "特別オファーと割引で売上を促進しましょう！期間限定プロモーションや限定割引を強調します。",
            },
        ],
    },

    ABOUT: {
        heading: "My QR Menuについて",
        headingPara: "リアルタイムの更新でレストランメニューの管理を簡素化します。",
        highlightHeading: "必要なものにすばやく簡単にアクセス",
        highlightPara: "すべてのメニュー機能がワンタップで利用可能です。",
        cards: {
            left: {
                heading: ["材料を簡単に追加", "QRメニューに"],
                alt: "材料を追加",
            },
            right: {
                heading: ["メニューダッシュボードに", "簡単にアクセス"],
                alt: "メニューダッシュボード",
            },
        },
    },

    FAQ: {
        heading: "質問がありますか？答えがあります。",
        subheading: "製品について知っておくべきことすべて。",
        items: [
            {
                question: "My QRMenuとは何ですか？",
                answer:
                    "My QRMenuは、レストランがQRコードを使ってメニューを瞬時に作成、更新、共有できるデジタルメニュープラットフォームです。",
            },
            {
                question: "作成後にメニューを更新できますか？",
                answer:
                    "はい、いつでもメニューを更新でき、顧客がQRコードをスキャンすると即座に反映されます。",
            },
            {
                question: "My QRMenuはどのように機能しますか？",
                answer:
                    "メニューを作成し、QRコードを生成し、顧客がスキャンすると最新のメニューが表示されます。",
            },
            {
                question: "QRコードをどのように共有しますか？",
                answer:
                    "QRコードをデジタルで共有するか、店舗で表示するために印刷できます。",
            },
            {
                question: "My QRMenuはモバイル対応ですか？",
                answer:
                    "はい、My QRMenuはスマートフォンやタブレットを含むすべてのデバイスに最適化されています。",
            },
            {
                question: "顧客レビューを収集できますか？",
                answer:
                    "はい、顧客レビューを有効にしてフィードバックを使用して提供内容を改善できます。",
            },
        ],
    },

    CONTACT: {
        heading: "お問い合わせ",
        subheading: "親切なチームがあなたのご連絡をお待ちしています。",
        firstName: "名",
        lastName: "姓",
        email: "メール",
        message: "メッセージ",
        firstNamePlaceholder: "名",
        lastNamePlaceholder: "姓",
        emailPlaceholder: "あなた@会社.com",
        messagePlaceholder: "メッセージを入力してください...",
        privacyConsent: "あなたは私たちの",
        privacyPolicy: "プライバシーポリシーに同意します",
        submitButton: "メッセージを送信",
        toast: {
            requiredConsent: "プライバシーポリシーに同意する必要があります。",
            submitting: "メッセージを送信しています...",
            success: "メッセージが正常に送信されました！",
            fail: "メッセージの送信に失敗しました。もう一度お試しください。",
            error: "エラーが発生しました。接続を確認してください。",
        },
    },

    HELP_PAGE: {
        title: "ヘルプセンター",
        description: "ご不明な点やサポートが必要な場合は、次の連絡先までお問い合わせください： ",
        contactEmail: "contact@myqrmenu.co",
        faqPrompt: "または以下のFAQをご覧ください。お探しのものが見つかる場合があります。",
    },

    FOOTER: {
        footerHeading: "シームレスなデジタルメニュー、シンプルに！",
        footerButton: "ウエイトリストに参加",
        footerConnect: "つながりましょう",
        footerTerms: "利用規約",
        footerHelp: "ヘルプセンター",
        footerPrivacy: "プライバシーポリシー",
        footerCopyright: `©${currentYear} すべての権利を保有します。`,
    },

    PRIVACY_POLICY: {
        title: "プライバシーポリシー",
        lastUpdated: "最終更新日: 2025年5月22日",
        content: `
            <article class="mb-12">
                <p class="mb-6 leading-relaxed">
                このプライバシーポリシーは、サービスの使用時に情報を収集、使用、および開示する際の当社のポリシーと手順について説明しています。
                </p>
                <p class="mb-6 leading-relaxed">
                当社は、サービスの提供および改善のために個人データを使用します。サービスを使用することにより、お客様はこのプライバシーポリシーに従った情報の収集および使用に同意したものとみなされます。
                </p>
            </article>

            <section class="mb-12">
                <header class="mb-6">
                <h2 class="text-2xl font-semibold">解釈と定義</h2>
                </header>
                <article class="mb-8">
                <h3 class="text-xl font-semibold mb-2">解釈</h3>
                <p class="mb-6 leading-relaxed">
                    最初の文字が大文字の単語は、以下の条件で定義された意味を持ちます。
                </p>
                </article>

                <article>
                <h3 class="text-xl font-semibold mb-4">定義</h3>
                <ul class="list-disc list-inside mb-6 space-y-3 text-gray-800">
                    <li><strong>アカウント</strong> とは、当社のサービスにアクセスするために作成された一意のアカウントを意味します。</li>
                    <li><strong>当社</strong> とは、<strong>My QR Menu,</strong> 英国ロンドンを指します。</li>
                    <li><strong>個人データ</strong> とは、識別された、または識別可能な個人に関連する情報を指します。</li>
                    <li><strong>お客様</strong> とは、サービスにアクセスまたは利用する個人を指します。</li>
                </ul>
                </article>
            </section>

            <section class="mb-12">
                <h2 class="text-2xl font-semibold mb-6">お問い合わせ</h2>
                <p>
                このプライバシーポリシーについてご質問がある場合は、当社までお問い合わせください。
                </p>
                <ul class="list-disc list-inside mt-2">
                <li>メール: <a href="mailto:hello@myqrmenu.co" class="text-gray-800 underline">hello@myqrmenu.co</a></li>
                </ul>
            </section>
        `
    },

    TERMS_AND_CONDITIONS: {
        title: "利用規約",
        lastUpdated: "最終更新日: 2025年5月22日",
        content: `
            <p class="leading-relaxed mb-6">
            当社のアプリまたはウェブサイトを使用する前に、これらの利用規約を注意深くお読みください。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">1. 解釈と定義</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">解釈</h3>
            <p class="leading-relaxed mb-4">
            最初の文字が大文字の単語は、以下の条件で定義された意味を持ちます。
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">定義</h3>
            <ul class="list-disc list-inside mb-6 leading-relaxed text-gray-800">
            <li><strong>アプリケーション</strong> とは、My QR Menu が提供するソフトウェアを意味します。</li>
            <li><strong>当社</strong> とは、英国ロンドンの My QR Menu を指します。</li>
            <li><strong>サービス</strong> とは、アプリケーションおよびウェブサイトを指します。</li>
            <li><strong>お客様</strong> とは、サービスにアクセスまたは利用する個人または企業を意味します。</li>
            </ul>

            <h2 class="text-2xl font-semibold mt-10 mb-4">2. 承認</h2>
            <p class="leading-relaxed mb-6">
            サービスにアクセスまたは利用することにより、お客様はこれらの規約に拘束されることに同意したものとみなされます。一部でも同意いただけない場合は、サービスをご利用いただけません。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">3. 他のウェブサイトへのリンク</h2>
            <p class="leading-relaxed mb-6">
            当社のサービスには、第三者のウェブサイトへのリンクが含まれている場合があります。当社は、その内容や慣行について責任を負いません。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">4. 終了</h2>
            <p class="leading-relaxed mb-6">
            当社は、理由の如何を問わず、事前の通知なしに、お客様のサービスへのアクセスを直ちに終了または停止する権利を留保します。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">5. 責任の制限</h2>
            <p class="leading-relaxed mb-6">
            法律で認められる最大限の範囲において、当社は、本サービスの使用から生じるいかなる損害についても責任を負いません。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">6. 「現状有姿」および「利用可能範囲内」の免責事項</h2>
            <p class="leading-relaxed mb-6">
            本サービスは「現状有姿」および「利用可能範囲内」でお客様に提供されます。エラーがないことや中断されないことを保証するものではありません。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">7. 準拠法</h2>
            <p class="leading-relaxed mb-6">
            これらの規約は、英国の法律に準拠するものとします。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">8. 紛争解決</h2>
            <p class="leading-relaxed mb-6">
            当社との間に紛争が生じた場合、法的措置を講じる前に、まず非公式に解決を試みることに同意するものとします。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">9. 欧州連合（EU）居住のお客様へ</h2>
            <p class="leading-relaxed mb-6">
            EUの消費者である場合、お客様は居住国の法律の強制規定による保護を受ける権利を有します。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">10. 米国の法的遵守</h2>
            <p class="leading-relaxed mb-6">
            お客様は、米国政府の制裁対象国に居住していないことを表明し、保証するものとします。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">11. 分離可能性および放棄</h2>
            <h3 class="text-xl font-semibold mt-6 mb-2">分離可能性</h3>
            <p class="leading-relaxed mb-4">
            本規約のいずれかの条項が執行不能と判断された場合でも、残りの条項は引き続き効力を有するものとします。
            </p>
            <h3 class="text-xl font-semibold mt-6 mb-2">放棄</h3>
            <p class="leading-relaxed mb-6">
            条項を執行しなかったとしても、その権利を放棄したことにはなりません。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">12. 翻訳の解釈</h2>
            <p class="leading-relaxed mb-6">
            本規約は翻訳されている場合があります。紛争が生じた場合は、英語版が優先されます。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">13. 本規約の変更</h2>
            <p class="leading-relaxed mb-6">
            当社はいつでも本規約を更新することができます。変更の際は、ウェブサイトに通知を掲載してお知らせします。
            </p>

            <h2 class="text-2xl font-semibold mt-10 mb-4">14. お問い合わせ</h2>
            <p class="leading-relaxed mb-2">これらの規約についてご質問がある場合は、当社までお問い合わせください。</p>
            <ul class="list-disc list-inside text-gray-800">
            <li>メールでのお問い合わせ: <a href="mailto:hello@myqrmenu.co" class="text-blue-600 underline">hello@myqrmenu.co</a></li>
            </ul>
        `
    }
};

export default locale;
